<template>
  <div>
    <!--卡片布局-->
    <el-card shadow="always">
      <!--操作栏-->
      <div class="search-items">
        <div>
          <el-input size="small" v-model="queryInfo.queryStr" placeholder="请输入课程或项目名进行查询" clearable @clear="loadData()">
            <el-button size="small" slot="append" icon="el-icon-search" @click="loadData()"></el-button>
          </el-input>
        </div>
      </div>
      <!--表格-->
      <el-table :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="index" width="40">
        </el-table-column>
        <el-table-column prop="cname"  width="180" label="课程名称">
        </el-table-column>
        <el-table-column prop="pname"   label="项目名称">
        </el-table-column>
        <el-table-column prop="tnames" width="120" label="项目负责人">
        </el-table-column>
        <el-table-column label="截止时间" width="140">
          <template slot-scope="scope">{{timeFormate(scope.row.deadline)}}</template>
        </el-table-column>
        <el-table-column width="90" label="审核状态">
          <template slot-scope="scope">
            <template v-if="scope.row.status=='1'">
              <p style="color:#df1834">已审核</p>
            </template>
            <template v-else>
              <p style="color:#60d58f">未审核</p>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="selectNumber" width="80" label="已选人数">
        </el-table-column>
        <el-table-column prop="selectSnames"  label="已选学生">
        </el-table-column>
        <el-table-column label="操作"  width="260" align="center">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="handleAudit(scope.row,1)" :disabled="auditBtnFlag(scope.row)">审核通过</el-button>
            <el-button type="warning" size="mini" @click="handleAudit(scope.row,0)" :disabled="!auditBtnFlag(scope.row)">取消审核</el-button>
            <el-button type="success" size="mini" @click="handleExport(scope.row)" >下载</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.currentPage" :page-sizes="[1,5,10,100,1000]" :page-size="queryInfo.pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { selectProjectTaskListByAccount,querySelectedStudents,updateProjectTask } from '@/api/projectTask'
import { updateStudentProjectAfterAudit } from '@/api/studentProject'
export default {
  inject: ['reload'],
  name: "courseAudit",
  data() {
    return {
      formLabelWidth: '120px',
      selectNos: [],
      tableData: [],       //分页查询所有数据
      queryInfo: {
        queryStr: '',
        currentPage: 1,
        pageSize: 100
      },
      total: 0,
      file: null,
      allTableData: [],     //表格所有数据
      multipleSelection: [],
      account: localStorage.getItem('account')
    }
  },
  created() {
    this.loadData();//分页条件获取所有学生信息
  },
  computed: {
    //时间
    timeFormate() {
      return function (time) {
        return moment(time).format('yyyy-MM-DD HH:mm')
      }
    },
    auditBtnFlag() {
      return function (item) {
        if (item.status == 1) {
          return true
        } else {
          return false
        }
      }
    }
  },
  methods: {
    //审核对象
    handleAudit(row, auditFlag) {
      let msg = (auditFlag === 1) ? '确认审核通过?' : '确认取消审核?'
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row['status'] = auditFlag
        this.submitAuditAction(row)
      });

    },

    /**
     * 提交审核
     */
    submitAuditAction(rowData) {
      updateStudentProjectAfterAudit(rowData).then(response => {
        this.$message({
          message: '操作成功！',
          type: 'success',
          duration: 2000
        });
      })
    },

    handleSelectionChange(val) {
      //监听多选框值动态变化的事件
      this.multipleSelection = val;
    },
    //加载列表数据
    loadData() {
      //分页条件获取所有学生信息     
      let params = {
        account: this.account,
        queryStr: this.queryInfo.queryStr,
        currentPage: this.queryInfo.currentPage,
        pageSize: this.queryInfo.pageSize
      }
      selectProjectTaskListByAccount(params).then(response => {
        let rowDatas = response.data.data.entries;
        _.forEach(rowDatas, (obj) => {
          let selectSnoArr = obj.selectSnos ? _.split(obj.selectSnos, ',') : []
          obj['selectNumber'] = selectSnoArr.length
        })
        this.tableData = rowDatas
        this.total = response.data.data.total//response.data.data.total;
      });

    },

    handleSizeChange(val) {
      //监听pageSize
      this.queryInfo.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      //监听currentPage
      this.queryInfo.currentPage = val;
      this.loadData();
    },
    getAllProject() {
      //用于excel的导出
      this.common.getAllData(this, this.apiUrl.selectAllProjects);
    },
    handleExport(row) {
      //导出excel
      require.ensure([], () => {
        let { exportJsonToExcel } = require("@excel/Export2Excel.js");
        // 表头
        let tHeader = [
          "学号",
          "姓名",
          "性别", 
          "班级",         
          "手机号码",
        ];
        //表头对应字段名，要和下面数据key对应
        let filterVal = [
          "sno",
          "name",
          "sex",
          "kclassName",
          "phone", 
        ];
        querySelectedStudents(row.id).then(resp => {
          let list = resp.data.data
          // 数据来源
          // let list = this.allTableData;
          let data = this.formatJson(filterVal, list); //数据格式化
          var index1 = "已选学生信息"; //导出时文件名
          exportJsonToExcel(tHeader, data, index1); //导出文件
        })
      });
    },
    formatJson(filterVal, jsonData) {
      // 导出excel数据格式化
      return jsonData.map(v => filterVal.map(j => {
        if(j=='sex'){
          return (v[j] &&v[j]==1)?'男':'女'
        }else{
          return v[j];
        }        
        }));
    },      
  }
}
</script>

